const LOGIN_ACTIONS = {
  LOGIN: {
    PENDING: 'LOGIN_PENDING',
    SUCCESS: 'LOGIN_SUCCESS',
    FAILURE: 'LOGIN_FAILURE',
  },
  LOGOUT: {
    PENDING: 'LOGOUT_PENDING',
    SUCCESS: 'LOGOUT_SUCCESS',
    FAILURE: 'LOGOUT_FAILURE',
  },
}

export const LOGIN_STATE = {
  REFRESHED: 'LOGIN_REFRESHED',
  IN_PROGRESS: 'LOGIN_IN_PROGRESS',
  UNAUTHORIZED: 'LOGIN_UNAUTHORIZED',
  AUTHORIZED: 'LOGIN_AUTHORIZED',
  ERROR: 'LOGIN_ERROR',
}

export default LOGIN_ACTIONS
